import { render, staticRenderFns } from "./WordCard.vue?vue&type=template&id=62c33d22&scoped=true"
import script from "./WordCard.vue?vue&type=script&lang=js"
export * from "./WordCard.vue?vue&type=script&lang=js"
import style0 from "./WordCard.vue?vue&type=style&index=0&id=62c33d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c33d22",
  null
  
)

export default component.exports